export const maskedPhoneNumber = /^\+7\s\(\d{3}\)\s\d{3}\-\d{2}\-\d{2}$/;